<div class="skeleton" [class.circle]="shape === 'circle'" [style.width]="width+widthUnit" [style.height]="height+heightUnit">
  <div [class.circle]="shape === 'circle'"  [style.width]="width+widthUnit" [style.height]="height+heightUnit"></div>
</div>
